import {getUrlParams} from '@/utils/urlUtils';
import {VIEW_TYPE} from './config';

// 暂时做仅展示文档区域逻辑 一切从简
export const isShowCurrentView = (view: string | null) => {
    const query = getUrlParams();
    if (query?.view === VIEW_TYPE.onlyContent) {
        return false;
    }
    return true;
};
